import React from "react";

export default function Logo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="222"
      height="89"
      viewBox="0 0 222 89"
      fill="none"
    >
      <g filter="url(#filter0_di_1_70400)">
        <path
          d="M2 2.91648C2 5.7659 51.682 73.8519 57.2538 78.5009C61.4326 82.1002 63.909 83 69.4808 83C73.3501 83 77.8385 82.2502 79.3862 81.5003C82.7912 79.7007 126.747 20.7628 137.426 3.66632C138.509 1.8667 136.033 1.71672 122.877 2.3166C109.876 2.91648 106.781 3.51635 104.924 5.91586C103.685 7.41555 95.173 19.1131 86.1962 31.7106L69.6356 54.6558L62.516 45.0578C58.6467 39.8089 50.1342 27.9613 43.7886 18.8132L32.1806 2.16664L17.1677 2.01667C8.80999 2.01667 2 2.46657 2 2.91648Z"
          fill="#7B76FF"
        />
        <path
          d="M50.1333 3.36618C48.4308 4.41597 50.7523 8.46513 60.9673 22.7122C68.0869 32.7601 74.7421 40.8585 75.5159 40.8585C77.528 41.0084 90.2193 22.5622 90.2193 19.5629C90.2193 18.3631 87.1239 14.014 83.4093 10.1148L76.5993 2.76631L64.5271 2.3164C57.7171 2.16643 51.3714 2.46637 50.1333 3.36618Z"
          fill="#7B76FF"
        />
        <path
          d="M161.375 46.445V83H167.179H172.983V46.445V9.89004H167.179H161.375V46.445Z"
          fill="#7B76FF"
        />
        <path
          d="M145.445 41.3803V67.25H151.249H157.053V41.3803V15.5106H151.249H145.445V41.3803Z"
          fill="#7B76FF"
        />
        <path
          d="M131.516 42.503V57.125H136.159H140.802V42.503V27.881H136.159H131.516V42.503Z"
          fill="#7B76FF"
        />
        <path
          d="M119.906 41.9388V48.125H123.389H126.871V41.9388V35.7525H123.389H119.906V41.9388Z"
          fill="#7B76FF"
        />
        <path
          d="M180.266 50.3775V62.75H182.587H184.909V50.3775V38.0051H182.587H180.266V50.3775Z"
          fill="#7B76FF"
        />
        <path
          d="M195.352 50.3771V60.5H197.673H199.995V50.3771V40.2542H197.673H195.352V50.3771Z"
          fill="#7B76FF"
        />
        <path
          d="M208.125 43.6337V48.1328H211.607H215.09V43.6337V39.1347H211.607H208.125V43.6337Z"
          fill="#7B76FF"
        />
        <path
          d="M180.266 30.1489V32.3984H182.587H184.909V30.1489V27.8994H182.587H180.266V30.1489Z"
          fill="#7B76FF"
        />
        <path
          d="M195.352 32.3833V34.6328H197.673H199.995V32.3833V30.1337H197.673H195.352V32.3833Z"
          fill="#7B76FF"
        />
        <path
          d="M106.015 52.4009C103.384 55.4003 100.134 60.0494 98.5861 62.8988C95.8002 67.8477 95.8002 68.1477 98.7409 73.3966C103.539 82.0948 106.325 83.1446 124.278 82.6947L140.065 82.2448L126.29 64.6984C118.861 54.9504 112.206 47.152 111.587 47.002C111.123 47.002 108.492 49.4015 106.015 52.4009Z"
          fill="#7B76FF"
        />
      </g>
      <defs>
        <filter
          id="filter0_di_1_70400"
          x="0"
          y="0"
          width="221.09"
          height="89"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="2" dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.396721 0 0 0 0 0.384444 0 0 0 0 0.720833 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1_70400"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1_70400"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-3" dy="5" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.910859 0 0 0 0 0.894531 0 0 0 0 0.9375 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_1_70400"
          />
        </filter>
      </defs>
    </svg>
  );
}
